class SalesboxContainer {
  private container: HTMLElement;
  private stickyHeader: HTMLElement;
  private stickyHeaderButton: HTMLElement;
  private isSticky = false;
  private onscrollTimeoutFunc;

  constructor(container: HTMLElement) {
    this.container = container;

    this.stickyHeader = container.querySelector("div.icp-sticky-header");
    if (!this.stickyHeader) {
      return;
    }
    this.stickyHeaderButton = this.stickyHeader.querySelector("a.btn-cta");

    if (this.stickyHeader) {
      window.addEventListener("scroll", () =>
        this.manageStickyHeaderVisibility()
      );
      this.stickyHeaderButton.addEventListener("click", () =>
        this.scrollToSalesbox()
      );
    }
  }

  private manageStickyHeaderVisibility() {
    clearTimeout(this.onscrollTimeoutFunc);
    this.onscrollTimeoutFunc = setTimeout(() => {
      let getSticky = this.getShouldBecomeSticky();
      if (getSticky !== this.isSticky) {
        this.stickyHeader.classList.toggle("get-sticky", getSticky);
        this.isSticky = getSticky;
      }
    }, 50);
  }

  private getShouldBecomeSticky() {
    let boundingTop = this.container.getBoundingClientRect().top;
    let isSalesboxOutSideViewport =
      boundingTop + this.container.clientHeight < 0;
    return isSalesboxOutSideViewport;
  }

  private scrollToSalesbox() {
    let boundingTop = this.container.getBoundingClientRect().top;
    let marginTop = parseInt(getComputedStyle(this.container).marginTop);
    let scrollToHeight = window.pageYOffset + (boundingTop - marginTop);
    window.scroll({ top: scrollToHeight, left: 0, behavior: "smooth" });
  }
}
Array.from(document.querySelectorAll(".icp-salesbox-container")).forEach(
  (block) => new SalesboxContainer(block as HTMLElement)
);
